<style>
    @import url('https://fonts.googleapis.com/css2?family=Noto+Sans:wght@600&family=Roboto+Slab&display=swap');
  </style>
<div class="form-container">
    <form>
        <div>
            <p class="item-header" style="font-family: Roboto Slab">Interests</p>
            <ul>
                <li *ngFor="let key of interestKeys">
                    <label class="checkbox" [htmlFor]="key">
                        <input type="checkbox" [id]="key" [name]="key" [value]="key" (change)="onCheckChange($event, key)">
                        <div>
                            <span class="checkbox-text" style="font-family: Roboto Slab">{{interestOptions[key]}}</span>
                            <img class="toggle-icon" src="assets/plus.svg" alt="">
                        </div>
                    </label>
                </li>
            </ul>
        </div>
        <button mat-raised-button style="font-family: Noto Sans" *ngIf="advanced===false" type="button" (click)="showAdvanced()">Advanced
            Settings</button>
        <div class="sl-item" *ngIf="advanced===true">
            <label class="item-header" style="font-family: Roboto Slab" for="username">Name</label>
            <input class="sl-input" style="font-family: Noto Sans" type="text" id="username" name="username" [(ngModel)]="name"><br>
        </div>
        <div class="sl-item" *ngIf="advanced===true">
            <label class="item-header" style="font-family: Roboto Slab" for="housing">Housing</label>
            <select class="sl-input" style="font-family: Noto Sans" name="housing" id="housing" [(ngModel)]="housing">
                <option *ngFor="let key of housingKeys" [value]="key">{{housingOptions[key]}}</option>
            </select>
        </div>
        <div class="sl-item" *ngIf="advanced===true">
            <label class="item-header" style="font-family: Roboto Slab" for="delete-user">Delete Account</label>
            <button mat-raised-button style="font-family: Noto Sans" id="delete-user" type="button" (click)="deleteUser()">Delete
                Account</button>
        </div>
        <button mat-raised-button style="font-family: Noto Sans" *ngIf="advanced===true" type="button" (click)="hideAdvanced()">Basic Settings</button>
        <button mat-raised-button type="submit"
        style="font-family: Noto Sans" value="submit" (click)="submit()">Update Profile</button>
    </form>
</div>